/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GovForumShow.vue?vue&type=template&id=35569714&scoped=true&"
import script from "./GovForumShow.vue?vue&type=script&setup=true&lang=js&"
export * from "./GovForumShow.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GovForumShow.vue?vue&type=style&index=0&id=35569714&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35569714",
  null
  
)

export default component.exports